import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import App from './App'
import VueAxios from 'vue-axios'
import router from './router/router'
import store from './store/store'
import BVToastPlugin from 'bootstrap-vue'
import VueLazyload from 'vue-lazyload'
import Vuelidate from 'vuelidate'
import VueTour from 'vue-tour'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueGtm from 'vue-gtm'
import VueGtag from 'vue-gtag'
import { axiosInstance } from './utils/axios-instance'
import vueDebounce from 'vue-debounce'
import { AuthMissingError } from './utils/errors'
import MauticVue from './utils/mautic'
import FirebaseVue from './utils/firebase'
import Hotjar from 'vue-hotjar'
import VueMatomo from 'vue-matomo'

Vue.config.productionTip = false
const isProd = process.env.NODE_ENV === 'production'
const isStage = process.env.NODE_ENV === 'staging'

Vue.use(VueGtag,
  {
    config: { id: process.env.GA_TRACING }
  },
  router
)
Vue.use(Vuelidate)
Vue.use(VueTour)
Vue.use(BVToastPlugin)
Vue.use(VueAxios, axiosInstance)
Vue.use(VueLazyload, {
  loading: '/static/diagram-placeholder.jpg'
})
Vue.use(VueReCaptcha, {
  siteKey: process.env.RECAPTCHA
})
Vue.use(VueGtm, {
  id: process.env.GTM,
  enabled: false,
  debug: !isProd,
  loadScript: true,
  vueRouter: router
})
Vue.use(vueDebounce)
Vue.use(FirebaseVue)
Vue.use(
  Hotjar,
  {
    id: '2961063',
    snippetVersion: 6,
    isProduction: isProd
  }
)

Vue.use(VueMatomo, {
  router: router,
  host: 'https://piwik.infodiagram.com',
  siteId: process.env.MAUTIC_SITE_ID,
  enableHeartBeatTimer: true,
  debug: !isProd,
  cookieDomain: process.env.MAUTIC_COOKIE_DOMAIN,
  domains: process.env.MAUTIC_DOMAINS,
  requireConsent: false,
  requireCookieConsent: false
})

if (isProd || isStage) {
  Sentry.init({
    dsn: process.env.SENTRY,
    environment: process.env.SENTRY_ENV
  })

  Vue.use(MauticVue, {
    trackerScript: 'https://clients.infodiagram.com/mtc.js',
    router: router,
    store: store
  })
}

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  async errorCaptured (err, vm, info) {
    console.log('errorCaptured', err, vm, info)
    let message = 'Unexpected error. Please let us know.'
    let propagate = true
    if (err instanceof AuthMissingError) {
      this.$store.dispatch('auth/logout')
      message = 'You have been logged out. Please log in again.'
      if (this.$route.name !== 'login') {
        await this.$router.push({ name: 'login' })
      } else {
        return false
      }
      propagate = false
    }
    this.$bvToast.toast(
      message,
      {
        title: 'Error',
        variant: 'danger',
        solid: true,
        autoHideDelay: 10000
      }
    )
    return propagate
  },
  render: h => h(App)
})
